
<template>
  <!--审核物业公司-->
  <div class="advanced-form">
    <a-form :form="form">
      <div class="card">
        <div class="card-head">
          <h3>基本信息</h3>
        </div>
        <div class="card-body">
          <a-row type="flex">
            <a-col v-for="(item, index) of baseInfo" :key="index" :span="8">
              <a-form-item class="value-indent" :label="item.label">
                <span class="ant-form-text">{{item.value}}</span>
              </a-form-item>
            </a-col>
          </a-row>
        </div>
      </div>

      <div class="card">
        <div class="card-head">
          <h3>公司资质</h3>
        </div>
        <div class="card-body">
          <a-form-item class="form-item-right long_2" v-for="(item, index) of companyInfo" :required="item.key==='contract_time'" :key="index" :label="item.label">
            <div v-if="item.key === 'business_img'" @click="showPic(item.value)" class="pic-box">
              <img :src="item.value" alt="">
            </div>

            <div v-if="item.key === 'legal_img'" @click="showPic(item.value)" class="pic-box">
              <img :src="item.value" alt="">
            </div>

            <a-date-picker v-if="item.key === 'contract_time'" v-decorator="['contract_time', contractTime]" :disabled="$route.query.status!=='0'" format="YYYY-MM-DD"/>

            <span v-if="['business_img', 'legal_img', 'contract_time'].every((el) => item.key !== el)" class="ant-form-text">{{item.value}}</span>
          </a-form-item>
        </div>
      </div>
    </a-form>

    <template v-if="isAudit">
      <x-toolbar :toolBarList="toolBarList" :btnLoading="btnLoading"></x-toolbar>
    </template>

    <!--查看图片的弹窗-->
    <a-modal
      class="img-modal"
      :visible="picVisible"
      @cancel="picVisible=false"
      width="auto"
      v-bind="$store.state.modalDetailConfig"
    >
      <img :src="picUrl" alt="">
    </a-modal>

    <!--审核的弹窗-->
    <a-modal
      title="审核"
      :visible="visible"
      @ok="handleSubmit"
      @cancel="visible=false"
      :confirmLoading="btnLoading.loading"
      centered
      :maskClosable="false"
      :keyboard="false"
      okText="确认"
      cancelText="取消"
      destroyOnClose
    >
      <a-form :form="modalForm">
        <a-form-item v-if="clickType === '1'" v-bind="$store.state.modal_ItemLayout" label="选择角色">
          <a-select
            v-decorator="['role_id', decoratorOptions.role_id]"
            :filterOption="filterOption"
            mode="multiple"
            showSearch
            allowClear
            placeholder="请选择角色"
          >
            <a-select-option v-for="(item, index) of roleList" :key="index" :value="item.value">
              {{item.label}}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item v-else v-bind="$store.state.modal_ItemLayout" label="拒绝原因">
          <a-textarea v-decorator="['verify_remark', decoratorOptions.verify_remark]" :rows="4" placeholder="请输入拒绝原因"/>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import mixin from '../../../js/mixins';
export default {
  mixins: [mixin.inputSearch],
  name: 'auditCompany',
  data () {
    return {
      routeQuery: '',
      picUrl: '',
      picVisible: false,
      isAudit: false,
      clickType: '',
      visible: false,
      btnLoading: { loading: false },
      roleList: [],
      toolBarList: [
        {text: '通过', handle: () => this.showModal('1'), type: 'primary', loading: true, authDisabled: true, key: 'pass'},
        {text: '拒绝', handle: () => this.showModal('2'), type: 'danger', authDisabled: true, key: 'reject'}
      ],
      baseInfo: [
        {key: 'area', label: '所属城市：', value: ''},
        {key: 'property_full_name', label: '公司名：', value: ''},
        {key: 'true_name', label: '联系人：', value: ''},
        {key: 'mobile_phone', label: '联系人手机号：', value: ''},
        {key: 'gps', label: 'GPS定位：', value: ''},
        {key: 'property_address', label: '公司地址：', value: ''},
        {key: 'contract_number', label: '合同编号：', value: ''}
      ],
      companyInfo: [
        {key: 'business_number', label: '营业执照号：', value: ''},
        {key: 'legal_name', label: '法人代表：', value: ''},
        {key: 'business_address', label: '注册地址：', value: ''},
        {key: 'business_img', label: '营业执照照片：', value: ''},
        {key: 'legal_img', label: '法人持身份证照：', value: ''},
        {key: 'contract_time', label: '合同期限：', value: this.Moment()}
      ],
      contractTime: {
        rules: [{ required: true, message: '请输入合同期限' }]
      },
      decoratorOptions: {
        role_id: {
          rules: [{ required: true, message: '请选择角色' }]
        },
        verify_remark: {
          validateTrigger: 'blur',
          rules: [{ required: true, message: '请输入拒绝原因' }]
        }
      }
    };
  },
  beforeCreate () {
    this.form = this.$form.createForm(this);
    this.modalForm = this.$form.createForm(this);
  },
  created () {
    // 1:查看，0:审核, 2:查看
    this.$route.query.status !== '0' ? this.isAudit = false : this.isAudit = true;
    this.propertyManageSelect();
    if (this.$route.query.id) {
      this.routeQuery = this.$route.query.id;
      this.getDetail();
    }
  },
  methods: {
    /* 查看图片 */
    showPic (url) {
      this.picUrl = url;
      this.picVisible = true;
    },
    /*  物业管理下拉（物业管理模块） */
    propertyManageSelect () {
      this.$get({
        url: '/select_list/property_manage_list',
        params: {}
      }).then(({data}) => {
        this.roleList = data.property_roles;
      });
    },
    /* 打开弹窗 */
    showModal (type) {
      this.form.validateFields((err, values) => {
        if (err) { return; }
        this.clickType = type;
        this.visible = true;
      });
    },
    /* 表单提交 */
    handleSubmit  () {
      this.modalForm.validateFields((err, values) => {
        if (err) { return; }
        let time = {...this.form.getFieldsValue(['contract_time'])};
        let formatTime = time.contract_time.format('YYYY-MM-DD HH:mm:ss');
        values.role_id && (values.role_id = values.role_id.join(','));
        values = {verify_status: this.clickType, contract_time: formatTime, ...values};
        this.$put({
          url: `/property/check/${this.routeQuery}`,
          params: values,
          btnLoading: this.btnLoading
        }).then((res) => {
          this.$store.commit('setOptData', true);
          this.visible = false;
          this.$message.success(`${res.msg}`).then((res) => {
            this.$router.go(-1);
          });
        });
      });
    },
    /* 获取详情 */
    getDetail () {
      this.$get({
        url: `/property/${this.routeQuery}`,
        params: {}
      }).then(({data}) => {
        for (let item in data) {
          this.baseInfo.forEach((el) => {
            el.key === 'area' && (el.value = `${data.province_name} ${data.city_name} ${data.district_name}`);
            el.key === 'gps' && (el.value = `经度: ${data.map_lat} 纬度: ${data.map_lng}`);
            if (el.key === item) {
              el.value = data[item];
            }
          });
          this.companyInfo.forEach((el) => {
            if (el.key === item) {
              el.value = data[item];
            }
          });
        }
        if (data.contract_time) {
          this.form.setFieldsValue({contract_time: this.Moment(data.contract_time)});
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/property/company/auditCompany.vue